/* eslint-disable global-require */
import React from 'react';
import { StyleSheet, View, Pressable } from 'react-native';
import Theme from 'Theme';
import type { StyleMap } from 'Types';
import iconMap from './iconMap';
import { CachedImage } from '../CachedImage';

const styles = StyleSheet.create({
    container: {
        zIndex: 9999,
        width: Theme.BU * 2,
        height: Theme.BU * 2
    },
    containerIn: {
        width: '100%',
        height: '100%'
    }
});

interface IconProps {
    onPress?: ((event?: unknown) => void) | (() => void);
    style?: any;
    tintColor?: string;
    name: string;
    hitSlop?: { top: number; bottom: number; left: number; right: number };
    testID?: string;
    useGestureHandler?: boolean;
    children?: JSX.Element
}

const Icon = ({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onPress,
    style,
    tintColor,
    name,
    hitSlop = { top: 10, bottom: 10, left: 10, right: 10 },
    testID,
    useGestureHandler = false,
    children
}: IconProps): JSX.Element => {
    const icon = children || (
        <CachedImage
            tintColor={tintColor}
            style={[styles.containerIn, { tintColor }]}
            source={iconMap[name]}
            resizeMode="stretch"
        />
    );

    if (onPress) {
        if (useGestureHandler)
            return (
                <Pressable
                    style={[styles.container, style]}
                    onPress={(event) => onPress(event)}
                    hitSlop={hitSlop}
                    testID={testID}
                >
                    {icon}
                </Pressable>
            );

        return (
            <Pressable
                style={[styles.container, style]}
                onPress={(event) => onPress(event)}
                hitSlop={hitSlop}
                testID={testID}
            >
                {icon}
            </Pressable>
        );
    }

    return (
        <CachedImage
            style={[styles.container, style]}
            source={iconMap[name]}
            resizeMode="stretch"
        />
    );
};

export default Icon;
